import { Card, CardBody } from "app/NativeComponents/common";
import React, { useEffect, useRef, useState } from "react";
import useResizeObserver from "use-resize-observer";

const useOutsideRefClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) callback();
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [ref]);
};

export const Popover = ({
  initiallyOpen,
  overlayContent,
  overlayStyle,
  children
}) => {
  const containerRef = useRef(null);
  const targetRef = useRef(null);
  const { height = 20 } = useResizeObserver({ ref: targetRef });
  const [open, setOpen] = useState(initiallyOpen);
  useOutsideRefClick(containerRef, () => setOpen(false));

  useEffect(() => {
    setOpen(initiallyOpen);
  }, [initiallyOpen]);

  return (
    <div ref={containerRef} style={{ position: "relative", cursor: "pointer" }}>
      <div
        ref={targetRef}
        onClick={() => setOpen(true)}
        onMouseEnter={() => setOpen(true)}
      >
        {children}
      </div>
      {open && (
        <Card
          style={{
            position: "absolute",
            right: 0,
            top: height - 10,
            cursor: "default",
            zIndex: 5,
            ...overlayStyle
          }}
        >
          {overlayContent}
        </Card>
      )}
    </div>
  );
};
